import React, { useState } from 'react';
import { useAuth } from '../AuthContext';
// ✨ Using Enhanced Learning Path Dashboard
import LearningPathDashboard from './EnhancedLearningPathDashboard';
import StudentLearningPathViewer from './StudentLearningPathViewer';

// Learning Path page with dashboard and topic navigation
const LearningPathPage = ({ onBackToDashboard }) => {
  console.log('🟢 LEARNING PATH PAGE RENDERED - DASHBOARD + TREE VIEW');
  
  const { userProfile } = useAuth();
  const [currentView, setCurrentView] = useState('dashboard'); // 'dashboard' or 'topic'
  const [selectedTopic, setSelectedTopic] = useState(null);
  
  const handleSelectTopic = (topic) => {
    console.log('🟢 Topic selected:', topic);
    setSelectedTopic(topic);
    setCurrentView('topic');
  };

  const handleBackToLearningPaths = () => {
    console.log('🟢 Back to Learning Path Dashboard');
    setCurrentView('dashboard');
    setSelectedTopic(null);
  };

  if (currentView === 'topic' && selectedTopic) {
    return (
      <StudentLearningPathViewer 
        selectedTopic={selectedTopic}
        onBack={handleBackToLearningPaths}
        userProfile={userProfile}
      />
    );
  }
  
  return (
    <LearningPathDashboard 
      onSelectTopic={handleSelectTopic}
      onBackToDashboard={onBackToDashboard}
    />
  );
};

export default LearningPathPage;